export default __webpack_public_path__ + "static/media/notepad.a814ef4f.png";